import { useForm } from "react-hook-form";
import { useState } from "react";
import DataBlockLabel from "../account/DataBlockLabel";
import { useRouter } from "next/router";
import ToastService from "../../services/Toast.Service";

export default function RememberPasswordForm() {
  const [passwordType, setPasswordType] = useState("password");
  const [passwordIcon, setPasswordIcon] = useState(
    "/assets/icon/show-icon.png"
  );
  const router = useRouter();

  //   Registreren
  const {
    register,
    handleSubmit,
    setError,
    watch,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {

    const promise = fetch(process.env.NEXT_PUBLIC_CRAFT_BASE_URL + "/api/reset-password", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response)
      .then(async (data) => {
        return {
          ok: data.ok,
          data: await data.json(),
        };
      })
      .then((data) => {
        if (!data.ok) {
          throw data.data.message;
        }
      });

    ToastService.promiseToast(promise, 'Laden...', 'Verzoek verwerkt, als uw e-mailadres bekend is ontvangt u op de mail een reset form.');
  };

  return (
    <div className="flex flex-col">
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-8">
        <div>
          <DataBlockLabel text="Wachtwoord vergeten" />
          <div className="mt-2 bg-white px-4 py-5 rounded-tl-lg rounded-br-lg space-y-6">
            <InputWrapper title="E-mail*">
              <input
                type="text"
                {...register("username", {
                  required: true,
                })}
                placeholder="E-mail"
                id="email"
                className={`bg-[#F6F5F3] w-full h-full text-sm py-2 px-5 mt-1 rounded-none border-b-2 outline-none text-olaf-green-700 font-medium appearance-none ${
                  errors.company_name ? "border-red-500" : "border-white"
                }`}
              />
              {errors.company_name?.type === "required" && (
                <div className="group shrink-0 absolute right-2">
                  <span className="absolute bottom-8 -right-2 text-sm opacity-0 shadow-xl w-max pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto px-4 py-2 bg-white flex border-b-2 border-red-500">
                    Dit veld is vereist
                  </span>
                </div>
              )}
            </InputWrapper>
          </div>
        </div>
        <button
          type="submit"
          className="mt-4 cursor-pointer w-[150px] mx-auto h-[40px] flex items-center justify-center rounded-tl-[10px] rounded-br-[10px] bg-olaf-green-500 text-white text-sm font-bold"
        >
          Versturen
        </button>
      </form>
    </div>
  );
}

function InputWrapper({ title, children }) {
  return (
    <div className="flex items-center">
      <div className="w-1/3 shrink-0">
        <p className="text-sm lg:text-base text-olaf-green-500">
          <strong>{title}</strong>
        </p>
      </div>
      <div className="ml-4 w-2/3 flex items-center">
        <div className="w-full">{children}</div>
      </div>
    </div>
  );
}
